import { c as _c } from "react/compiler-runtime";
import { useCallback } from 'react';
import { clearUserTokenCookies } from 'commons/localStorage';
import useResetUserData from './useResetUserData';
const useLogoutClient = () => {
  const $ = _c(2);
  const resetUserData = useResetUserData();
  let t0;
  if ($[0] !== resetUserData) {
    t0 = () => {
      resetUserData();
      clearUserTokenCookies();
    };
    $[0] = resetUserData;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const logoutClient = t0;
  return logoutClient;
};
export default useLogoutClient;